<ng-container *ngIf="automationContext === context.AUTOMATION_CONTEXT_SMB && isSMSAction">
  <ng-container *ngIf="productName$ | async as productName; else loadingStencil">
    <glxy-alert class="info-banner" type="info">
      {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_SMS_INBOX.QUOTA_DISCLAIMER' | translate: { productName: productName } }}
    </glxy-alert>
  </ng-container>
</ng-container>

<div class="content">
  <glxy-form-field [required]="true">
    <glxy-label>{{ messageBodyLabel | translate }}</glxy-label>
    <glxy-label-hint *ngIf="messageBodyHint">{{ messageBodyHint | translate }}</glxy-label-hint>
    <textarea
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="4"
      cdkAutosizeMaxRows="8"
      [formControl]="messageBodyFormControl"
      id="message-body"
      [maxLength]="1000"
    ></textarea>
    <glxy-hint align="right">{{ messageBodyFormControl?.value?.length || 0 }} / 1000</glxy-hint>

    <automata-automation-variable-menu
      [supportedDataTypes]="allDataTypes"
      matSuffix
      (variableSelected)="insertVariable('message-body', messageBodyFormControl, $event)"
    ></automata-automation-variable-menu>
  </glxy-form-field>
</div>

<ng-template #loadingStencil>
  <div class="loading stencil-shimmer"></div>
</ng-template>
